export default import.meta.ROLLUP_FILE_URL_Bo2zq9ko;